import { OrderDetailResponse } from '@/types/Order'

export const sortOrders = (orders: OrderDetailResponse[] = []) =>
    [...orders].sort(
        (a, b) =>
            Date.parse(b.created_on || '0') - Date.parse(a.created_on || '0')
    )
